import { z } from 'zod';
// ---------------------------------------------------------------------------
// Recipe categories
// ---------------------------------------------------------------------------
export const RECIPE_CATEGORIES = [
    'starter',
    'main_dish',
    'side_dish',
    'dessert',
    'snack',
    'drink',
    'sauce',
    'bread',
    'soup',
];
export const recipeCategorySchema = z.enum(RECIPE_CATEGORIES);
export const RECIPE_CATEGORY_LABELS = {
    starter: { fr: 'Entrée', en: 'Starter' },
    main_dish: { fr: 'Plat principal', en: 'Main dish' },
    side_dish: { fr: 'Accompagnement', en: 'Side dish' },
    dessert: { fr: 'Dessert', en: 'Dessert' },
    snack: { fr: 'En-cas', en: 'Snack' },
    drink: { fr: 'Boisson', en: 'Drink' },
    sauce: { fr: 'Sauce', en: 'Sauce' },
    bread: { fr: 'Pain', en: 'Bread' },
    soup: { fr: 'Soupe', en: 'Soup' },
};
// ---------------------------------------------------------------------------
// Ingredient categories (for shopping list organization)
// ---------------------------------------------------------------------------
export const INGREDIENT_CATEGORIES = [
    'produce',
    'meat',
    'fish',
    'dairy',
    'bakery',
    'grocery',
    'frozen',
    'canned',
    'spices',
    'beverages',
    'other',
];
export const ingredientCategorySchema = z.enum(INGREDIENT_CATEGORIES);
export const INGREDIENT_CATEGORY_LABELS = {
    produce: { fr: 'Fruits & légumes', en: 'Produce' },
    meat: { fr: 'Boucherie', en: 'Meat' },
    fish: { fr: 'Poissonnerie', en: 'Fish' },
    dairy: { fr: 'Crèmerie', en: 'Dairy' },
    bakery: { fr: 'Boulangerie', en: 'Bakery' },
    grocery: { fr: 'Épicerie', en: 'Grocery' },
    frozen: { fr: 'Surgelés', en: 'Frozen' },
    canned: { fr: 'Conserves', en: 'Canned goods' },
    spices: { fr: 'Épices & condiments', en: 'Spices & condiments' },
    beverages: { fr: 'Boissons', en: 'Beverages' },
    other: { fr: 'Autres', en: 'Other' },
};
/**
 * Material Community Icons name for each aisle.
 *
 * An aisle heading is scanned, not read: standing in the shop, the glyph is
 * what finds « Crèmerie » among ten headings before the word is spelled out.
 * They live here beside the labels, for the same reason the labels do — the
 * carnet, the courses and the ingredient sheet must not each pick their own.
 */
export const INGREDIENT_CATEGORY_ICONS = {
    produce: 'food-apple-outline',
    meat: 'food-steak',
    fish: 'fish',
    dairy: 'cheese',
    bakery: 'baguette',
    grocery: 'pasta',
    frozen: 'snowflake',
    canned: 'food-variant',
    spices: 'shaker-outline',
    beverages: 'bottle-soda-outline',
    other: 'basket-outline',
};
//# sourceMappingURL=categories.js.map